import { PropsWithChildren, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ExtensionIcon from '@material-ui/icons/Extension';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import HistoryIcon from '@material-ui/icons/History';
import CategoryIcon from '@material-ui/icons/Category';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import StorageIcon from '@material-ui/icons/Storage';
import LogoFull from './LogoFull.tsx';
import LogoIcon from './LogoIcon.tsx';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';

// RBAC 权限管理图标
import SecurityIcon from '@material-ui/icons/Security';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';


const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => {
  // 将当前主题模式同步到 html 元素的 data-theme 属性
  // 供全局 CSS 根据主题模式做条件样式覆盖（如 SidebarSubmenu 修复）
  const theme = useTheme();
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme.palette.type);
  }, [theme.palette.type]);

  return (
    <SidebarPage>
      <Sidebar>
        <SidebarLogo />
        <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
          <SidebarSearchModal />
        </SidebarGroup>
        <SidebarDivider />
        <SidebarGroup label="Menu" icon={<MenuIcon />}>
          {/* Global nav, not org-specific */}
          <SidebarItem icon={HomeIcon} to="/" text="Home" />
          <SidebarItem icon={ViewModuleIcon} to="systems" text="Systems" />
          <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
          {/* <SidebarItem icon={GroupIcon} to="teams" text="Teams" /> */}
          <MyGroupsSidebarItem
            singularTitle="My Group"
            pluralTitle="My Groups"
            icon={GroupIcon}
          />
          <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
          <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
          <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
          <SidebarItem icon={HistoryIcon} to="create/tasks" text="Task History" />
          {/* End global nav */}
          <SidebarDivider />
          <SidebarScrollWrapper>
            {/* 快捷方式已移至 Home 页面 */}
          </SidebarScrollWrapper>
        </SidebarGroup>
        <SidebarSpace />
        <SidebarDivider />
        <SidebarGroup
          label="Settings"
          icon={<UserSettingsSignInAvatar />}
          to="/settings"
        >
          <SidebarItem icon={StorageIcon} to="resourcing" text="Resourcing" />
          <SidebarSettings />
          <SidebarItem icon={SecurityIcon} to="rbac" text="权限管理" />
        </SidebarGroup>
      </Sidebar>
      {children}
    </SidebarPage>
  );
};
